/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherBugReportSettings, FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherBugReportSettingsFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherBugReportSettingsToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherBugReportSettings';
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsBugReportFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsBugReportFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsBugReportFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherBugReportSettings(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherBugReportSettingsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsBugReportToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsBugReportToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsBugReportToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherBugReportSettings(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherBugReportSettingsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsBugReport.js.map